import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { customStyles } from "../../tableStyles";
import "../css/OrganisationList.css";
import "../css/CrmSearchBar.css";
import "../css/EmailCopyControl.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faTrash, faCheck, faMagnifyingGlass, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { formatOrgTypesLabel } from "../../utils/orgTypeHelpers";
import DeleteConfirmModal, { useDeleteConfirm } from "../ems/DeleteConfirmModal";
import InviteOrgModal, { useInviteOrgModal } from "./InviteOrgModal";
import { DataTableLoader, GoldLoader } from "../shared/Loaders";

function OrganisationList() {
  const [organisations, setOrganisations] = useState([]);
  const [filteredOrganisations, setFilteredOrganisations] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [orgTypes, setOrgTypes] = useState({});
  // const [countries, setCountries] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const deleteConfirm = useDeleteConfirm();
  const inviteModal = useInviteOrgModal();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const orgResponse = await axios.get(`${process.env.REACT_APP_API_URL}/organisations`);
        // const orgTypeResponse = await axios.get(`${process.env.REACT_APP_API_URL}/org-types`);
        // const countryResponse = await axios.get(`${process.env.REACT_APP_API_URL}/countries`);

        // const orgTypesMap = orgTypeResponse.data.reduce((map, type) => {
        //   map[type._id] = type.org_type;
        //   return map;
        // }, {});

        // const countriesMap = countryResponse.data.reduce((map, country) => {
        //   map[country._id] = country.code;
        //   return map;
        // }, {});

        setOrganisations(orgResponse.data);
        setFilteredOrganisations(orgResponse.data);
        // setOrgTypes(orgTypesMap);
        // setCountries(countriesMap);       
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (event) => {

    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = organisations.filter((org) =>
      (org.name || "").toLowerCase().includes(value) ||
      (org.email || "").toLowerCase().includes(value)
    );

    setFilteredOrganisations(filtered);
  };
  
  const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  alert("Email copied!");
};

  const handleDelete = (org) => {
    deleteConfirm.ask({ id: org._id, name: org.name || "this organisation" });
  };

  const handleInvite = (org) => {
    inviteModal.ask({ id: org._id, name: org.name || "this organisation", email: org.email || "" });
  };

  const submitInvite = async () => {
    const id = inviteModal.pending?.id;
    if (!id || !inviteModal.email.trim()) return;
    inviteModal.setBusy(true);
    inviteModal.setError("");
    try {
      const API_URL =
        process.env.REACT_APP_API_URL ||
        (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '/api');
      await axios.post(`${API_URL}/auth/org-invite`, {
        org_id: id,
        email: inviteModal.email.trim(),
      });
      inviteModal.setSuccess(`Invite sent to ${inviteModal.email.trim()}`);
    } catch (err) {
      inviteModal.setError(err?.response?.data?.msg || "Failed to send invite.");
    } finally {
      inviteModal.setBusy(false);
    }
  };

  const confirmDelete = async () => {
    const id = deleteConfirm.pending?.id;
    if (!id) return;
    deleteConfirm.setBusy(true);
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/organisations/${id}`);
      setOrganisations((prev) => prev.filter((o) => o._id !== id));
      setFilteredOrganisations((prev) => prev.filter((o) => o._id !== id));
      deleteConfirm.clear();
    } catch (err) {
      console.error("Delete failed:", err);
      deleteConfirm.setError("Failed to delete organisation.");
      deleteConfirm.setBusy(false);
    }
  };

const columns = [
  {
    name: "#",
    cell: (row, index) => index + 1,
    width: "60px",
  },
  {
    name: "Logo",
    cell: (row) => (
      <img
        src={row.logo ? `/images/${row.logo}` : "/images/org_logo1.png"}
        alt={row.name || "Logo"}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "6px",
          objectFit: "contain",
        }}
      />
    ),
    width: "100px",
  },
  {
    name: "Name",
    selector: (row) => row.name,
    cell: (row) => (
      <span
        onClick={() =>
          navigate(`/organisation/${row._id}`, {
            state: { organisation: row },
          })
        }
        style={{
          color :"#000",
          cursor: "pointer",
        }}
      >
        {row.name || "Unnamed Organisation"}
      </span>
    ),
    sortable: true,
  },
  {
    name: "Org. Type",
    selector: (row) => formatOrgTypesLabel(row.org_type_id),
    sortable: true,
  },
  {
    name: "Email",
    selector: (row) => row.email || "-",
    sortable: true,
    style: { paddingLeft: '10px' },
    cell: (row) => (
    <div className="orgns-email-copy-cell">
      <span className="orgns-email-text">{row.email}</span>
      <button
        type="button"
        className="orgns-email-copy-btn"
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard(row.email);
        }}
        title="Copy Email"
      >
      <FontAwesomeIcon icon={faCopy} style={{ color: '#D9A128' }} />
       </button>
       </div>
      )
  },

  {
    name: "Country Code",
    selector: (row) => row.country_id?.code || "N/A",
    sortable: true,
  },

  {
    name: "Los Angeles 2028",
    selector: (row) => (row.status === 1 || row.status === "1" ? "Yes" : "No"),
    cell: (row) => {
      const isLa2028 = row.status === 1 || row.status === "1";
      return (
        <span className="orgns-la2028-cell">
          {isLa2028 ? (
            <>
              Yes <FontAwesomeIcon icon={faCheck} className="orgns-la2028-check" />
            </>
          ) : (
            "No"
          )}
        </span>
      );
    },
    sortable: true,
  },


  {
    name: "Invite",
    cell: (row) => (
      <button
        type="button"
        className="orgns-invite-btn"
        onClick={(e) => { e.stopPropagation(); handleInvite(row); }}
        title="Invite to portal"
      >
        <FontAwesomeIcon icon={faEnvelope} />
      </button>
    ),
    width: "80px",
  },
  {
    name: "Delete",
    cell: (row) => (
      <button
        type="button"
        className="orgns-delete-btn"
        onClick={(e) => { e.stopPropagation(); handleDelete(row); }}
        title="Delete"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    ),
    width: "80px",
  },
];

if (loading && organisations.length === 0) {
  return <GoldLoader label="Loading..." variant="page" />;
}

return(
    <div className="crm-list-page">
      <div className="crm-list-toolbar d-flex justify-content-between mb-1">
        <div className="w-25 me-3 mb-1">
          <div className="crm-search-wrapper">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="crm-search-icon" />
            <input
              type="text"
              placeholder="Search by name"
              className="crm-search-input form-control search-input"
              value={searchTerm}
              onChange={handleSearch}
              title="Search organisations"
            />
          </div>
        </div>  
     </div>
      <div className="crm-orgns-table-wrapper">
  <DataTable
    columns={columns}
    data={filteredOrganisations}
    progressPending={loading}
    progressComponent={<DataTableLoader />}
    pagination
    paginationPerPage={50}
    paginationComponentOptions={{ noRowsPerPage: true }}
    highlightOnHover
    striped
    responsive
    customStyles={customStyles}
  />
</div>
      {deleteConfirm.pending && (
        <DeleteConfirmModal
          name={deleteConfirm.pending.name}
          error={deleteConfirm.error}
          busy={deleteConfirm.busy}
          onConfirm={confirmDelete}
          onCancel={deleteConfirm.clear}
        />
      )}
      {inviteModal.pending && (
        <InviteOrgModal
          name={inviteModal.pending.name}
          email={inviteModal.email}
          onEmailChange={inviteModal.setEmail}
          onSubmit={submitInvite}
          onCancel={inviteModal.clear}
          error={inviteModal.error}
          success={inviteModal.success}
          busy={inviteModal.busy}
        />
      )}
    </div>
);
  
}

export default OrganisationList;
